import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/mobileHeader.css';
import MobileOffcanvasMenu from './MobileOffcanvasMenu';
import { getSubcategories } from '../functions/Categories';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Header() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [categories, setCategories] = useState({
    India: [],
    International: [],
    Weekend: [],
    More: []
  });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [mobilePlaceholder, setMobilePlaceholder] = useState("");
  const [bannerImageUrl, setBannerImageUrl] = useState(null);
  const navigate = useNavigate();

  // Fetch categories/subcategories from Firestore
  useEffect(() => {
    const fetchAll = async () => {
      const india = await getSubcategories("india");
      const international = await getSubcategories("international");
      const weekend = await getSubcategories("weekend");
      const more = await getSubcategories("more");
      setCategories({
        India: india,
        International: international,
        Weekend: weekend,
        More: more
      });
    };
    fetchAll();
  }, []);

  // Fetch Banner Image from Firestore
  useEffect(() => {
    async function fetchBannerImage() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data && data["Banner Image"] && data["Banner Image"].url) {
            setBannerImageUrl(data["Banner Image"].url);
          }
        }
      } catch (err) {
        setBannerImageUrl(null);
      }
    }
    fetchBannerImage();
  }, []);

  const handleToggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
  };

  const handleMobileSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  // Typing animation for mobile search placeholder
  useEffect(() => {
    const destinations = [
      'Ladakh',
      'Manali',
      'Spiti',
      'Romantic Getaways',
      'Kashmir',
      'Meghalaya',
      'Bali',
      'Dubai'
    ];
    let destIdx = 0;
    let charIdx = 0;
    let typing = true;
    let timeoutId;

    function type() {
      if (typing) {
        if (charIdx <= destinations[destIdx].length) {
          setMobilePlaceholder(destinations[destIdx].slice(0, charIdx));
          charIdx++;
          timeoutId = setTimeout(type, 90);
        } else {
          typing = false;
          timeoutId = setTimeout(type, 1200);
        }
      } else {
        if (charIdx > 0) {
          setMobilePlaceholder(destinations[destIdx].slice(0, charIdx));
          charIdx--;
          timeoutId = setTimeout(type, 40);
        } else {
          typing = true;
          destIdx = (destIdx + 1) % destinations.length;
          timeoutId = setTimeout(type, 500);
        }
      }
    }
    type();
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-secondary py-2 desktop-nav d-none d-lg-block text-white">
        <div className="container">
          <Link className="navbar-brand text-white" to="/">
            <img src="/assets/images/trekstunner.png" alt="Swayyourway Logo" height="40" />
          </Link>

          <div className="d-flex order-lg-last align-items-center">
            <div className="call-us me-3 d-none d-md-block">
              <div className="d-flex align-items-center text-white">
                <i className="fas fa-phone-alt me-2"></i>
                <div>
                  <small className="text-white d-block">Call Us</small>
                  <a href="tel:+919220424206" className="fw-bold text-white text-decoration-none">
                    +91 92204 24206
                  </a>
                </div>
              </div>
            </div>

            <Link
              to="/admin"
              className="btn btn-primary px-4 rounded-pill"
              style={{ backgroundColor: '#FFA500', borderColor: '#FFA500', fontWeight: 'bold' }}
            >
              Admin
            </Link>

            <button className="navbar-toggler ms-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setOpenDropdown('trending')}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link className="nav-link dropdown-toggle btn btn-outline-success rounded-pill px-3 me-2 text-white" to="/" role="button" data-bs-toggle="dropdown">
                  Trending Destinations
                  <span className="good-friday-badge">New</span>
                </Link>
                <ul className={`dropdown-menu${openDropdown === 'trending' ? ' show' : ''}`}>
                  <li>
                    <Link className="dropdown-item" to="/destinations?location=trending-india">
                      India
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/destinations?location=trending-international">
                      International
                    </Link>
                  </li>
                </ul>
              </li>
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setOpenDropdown('india')}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link className="nav-link dropdown-toggle text-white" to="#" role="button" data-bs-toggle="dropdown">
                  India
                </Link>
                <div className={`dropdown-menu p-3${openDropdown === 'india' ? ' show' : ''}`} style={{ minWidth: 400 }}>
                  <div className="row">
                    {categories.India && categories.India.length > 0 && (
                      <>
                        <div className="col-6">
                          {categories.India.slice(0, Math.ceil(categories.India.length / 2)).map((name, idx) => (
                            <Link
                              className="dropdown-item"
                              to={`/destinations?location=${encodeURIComponent(name)}`}
                              key={name + idx}
                            >
                              {name}
                            </Link>
                          ))}
                        </div>
                        <div className="col-6">
                          {categories.India.slice(Math.ceil(categories.India.length / 2)).map((name, idx) => (
                            <Link
                              className="dropdown-item"
                              to={`/destinations?location=${encodeURIComponent(name)}`}
                              key={name + idx + 100}
                            >
                              {name}
                            </Link>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </li>
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setOpenDropdown('international')}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link className="nav-link dropdown-toggle text-white" to="#" role="button" data-bs-toggle="dropdown">
                  International
                </Link>
                <div className={`dropdown-menu p-3${openDropdown === 'international' ? ' show' : ''}`} style={{ minWidth: 400 }}>
                  <div className="row">
                    {categories.International && categories.International.length > 0 && (
                      <>
                        <div className="col-6">
                          {categories.International.slice(0, Math.ceil(categories.International.length / 2)).map((name, idx) => (
                            <Link
                              className="dropdown-item"
                              to={`/destinations?location=${encodeURIComponent(name)}`}
                              key={name + idx}
                            >
                              {name}
                            </Link>
                          ))}
                        </div>
                        <div className="col-6">
                          {categories.International.slice(Math.ceil(categories.International.length / 2)).map((name, idx) => (
                            <Link
                              className="dropdown-item"
                              to={`/destinations?location=${encodeURIComponent(name)}`}
                              key={name + idx + 100}
                            >
                              {name}
                            </Link>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </li>
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setOpenDropdown('weekend')}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link className="nav-link dropdown-toggle text-white" to="/" role="button" data-bs-toggle="dropdown">
                  Weekend Trips
                </Link>
                <ul className={`dropdown-menu${openDropdown === 'weekend' ? ' show' : ''}`}>
                  {categories.Weekend && categories.Weekend.length > 0 ? (
                    categories.Weekend.map((name, idx) => (
                      <li key={name + idx}>
                        <Link className="dropdown-item" to={`/destinations?location=${encodeURIComponent(name)}`}>
                          {name}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li><span className="dropdown-item text-muted">No options</span></li>
                  )}
                </ul>
              </li>
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setOpenDropdown('more')}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link className="nav-link dropdown-toggle text-white" to="/" role="button" data-bs-toggle="dropdown">
                  More
                </Link>
                <ul className={`dropdown-menu${openDropdown === 'more' ? ' show' : ''}`}>
                  {categories.More && categories.More.length > 0 ? (
                    categories.More.map((name, idx) => (
                      <li key={name + idx}>
                        <Link className="dropdown-item" to={`/destinations?location=${encodeURIComponent(name)}`}>
                          {name}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li><span className="dropdown-item text-muted">No options</span></li>
                  )}
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="mobile-gradient-wrapper">
        <nav className="navbar navbar-dark bg-secondary py-2 mobile-nav d-block d-lg-none">
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src="/assets/images/syw-logo.png" alt="Swayyourway Logo" height="80" />
            </Link>
            <div className="d-flex align-items-center">
              <a href="tel:+919220424206" className="me-3">
                <i className="fas fa-phone-alt"></i>
              </a>
              <button
                className="navbar-toggler"
                type="button"
                onClick={handleToggleOffcanvas}
                aria-controls="mobileMenu"
                aria-expanded={showOffcanvas}
              >
                <i className="fas fa-bars"></i>
              </button>
            </div>
          </div>
        </nav>

        <div className="mobile-search d-lg-none">
          <div className="container">
            <div className="search-wrapper">
              <form className="search-form" onSubmit={handleMobileSearch}>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control search-input"
                    placeholder={mobilePlaceholder || "Search destinations..."}
                    aria-label="Search"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                  />
                  <button className="btn search-btn" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="mobile-stats d-lg-none">
          <div className="container">
            <div className="row">
              <div className="col-6">
                <div className="mobile-stat-item">
                  <i className="fas fa-star"></i> <b>4.9 Star Rating</b>
                </div>
              </div>
              <div className="col-6">
                <div className="mobile-stat-item">
                  <i className="fas fa-users"></i> <b>5261+ Trips</b>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-banner d-lg-none">
          <div className="container">
            <div className="banner-card">
              <img
                src={bannerImageUrl || "https://t3.ftcdn.net/jpg/03/20/06/16/360_F_320061630_qTwTYsIEPJO62ubp5bzF41Pob4oJug5b.jpg"}
                alt="Good Friday Long Weekend"
                className="img-fluid"
              />
            </div>
          </div>
        </div>

        <div className="mobile-categories d-lg-none">
          <div className="container">
            <div className="categories-scroll-container">
              <div className="categories-wrapper">
                <div
                  className="category-item"
                  onClick={() => navigate('/destinations?location=india')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="category-icon">
                    <img src="https://storage.justwravel.com/homepage/home-categories/-JustWravel-1739195348-Ladakh.jpg" alt="Ladakh" className="img-fluid rounded-circle" />
                  </div>
                  <div className="category-name">India</div>
                </div>
                <div
                  className="category-item"
                  onClick={() => navigate('/destinations?location=international')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="category-icon">
                    <img src="https://storage.justwravel.com/homepage/home-categories/-JustWravel-1739195348-Ladakh.jpg" alt="Spiti" className="img-fluid rounded-circle" />
                  </div>
                  <div className="category-name">International</div>
                </div>
                <div
                  className="category-item"
                  onClick={() => navigate('/destinations?location=romantic')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="category-icon">
                    <img src="https://storage.justwravel.com/homepage/home-categories/-JustWravel-1739195348-Ladakh.jpg" alt="Himalayan Treks" className="img-fluid rounded-circle" />
                  </div>
                  <div className="category-name">Romantic Getaways</div>
                </div>
                <div
                  className="category-item"
                  onClick={() => navigate('/destinations?location=backpacking')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="category-icon">
                    <img src="https://storage.justwravel.com/homepage/home-categories/-JustWravel-1739195348-Ladakh.jpg" alt="International" className="img-fluid rounded-circle" />
                  </div>
                  <div className="category-name">Backpacking</div>
                </div>
                <div
                  className="category-item"
                  onClick={() => navigate('/destinations?location=Weekend%20Trips')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="category-icon">
                    <img src="https://storage.justwravel.com/homepage/home-categories/-JustWravel-1739195348-Ladakh.jpg" alt="Weekend Trips" className="img-fluid rounded-circle" />
                  </div>
                  <div className="category-name">Weekend Trips</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <MobileOffcanvasMenu show={showOffcanvas} handleClose={handleCloseOffcanvas} categories={categories} />
    </>
  );
}

export default Header;